import "./index.css";
import React from "react";
import loadImage from "blueimp-load-image";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import NoteItem from "../../components/NoteItem";
import {
  StageOptions,
  SalesManagerOptions,
  CampaignManagerOptions,
} from "../../Constants/brand";
import {
  Top10Options,
  TerritoryOptions,
  CurrencyOptions,
} from "../../Constants/retailer";
import { idealTextColor } from "../../functions";
import { Fragment } from "react";
import Checkbox from "../BespokeCRMTabs/components/Checkbox";
import ConfirmationModal from "../../components/ConfirmationModal";
import MenuList from "./components/MenuList";
import SingleValue from "./components/SingleValue";
import SingleStageMenuList from "./components/SingleStageMenuList";
import SingleStageValue from "./components/SingleStageValue";
import Dropdown from "../../components/Dropdown";
import { interfaceOptions, methodOptions } from "./constants";

const user_img = require("../../assets/media/profile/avatar.png");

class Brand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      loading: false,
      img_loading: false,
      agencies: [],
      brand_name: "",
      brand_url: "",
      description: "",
      is_property_brand: false,
      is_tasktool_need: false,
      is_ecochat_need: false,
      is_fulluser_creatable: false,
      is_lightuser_creatable: true,
      umbrella: false,
      programme: {
        management_fee: {
          active: true,
          price: 0,
        },
        referral_fee: {
          active: true,
          price: 0,
        },
        review_fee: {
          active: true,
          price: 0,
        },
        marketplace_fee: {
          active: true,
          percent: 0,
        },
        linked_retail_incentive: {
          active: true,
          percent: 0,
        },
      },
      sector: "",
      allSectors: [],
      salesStage: "",
      salesManager: "",
      trialSize: "",
      smsSender: "",
      bespokeUrl: "",
      bespokeCrmUrl: "",
      potentialSize: "",
      interestInCommunity: true,
      interestInConcierge: true,
      ticketsAndTaskersIncluded: true,
      discountsIncluded: false,
      registeredCompanyName: "",
      registeredCompanyID: "",
      territory: {
        value: TerritoryOptions[0],
        label: TerritoryOptions[0],
      },
      registeredPostcode: "",
      registeredAddress: "",
      registeredStreet: "",
      registeredTown: "",
      top10licensor: Top10Options[0],
      top10propspect: Top10Options[0],
      permissions: {
        // tokenOffers: true,
        // earnTokens: true,
        // ecopay: true,
        // feeds: true,
        // friends: true,
        // community: true,
        // polls: true,
        // shop: true,
        // myId: true,
        // wallet: true,
        // timeline: true,
        // integration: true,
      },
      notes: [],
      noteViewVisible: true,
      mynote: "",
      edit_hex: false,
      edit_icon_style: false,
      saveChanges: {},
      contractStartDate: null,
      contractLength: null,
    };
  }
  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      console.log("brand:", brand);
      this.setState({ username, role, brand, loading: true });
      const allSectors = await Firebase.getAllSectors();
      this.setState({ allSectors });
      Firebase.getBrandDataByID(brand, (res) => {
        if (res.white === true)
          this.setState({ icon_style: { value: "white", label: "White" } });
        else if (res.white === false)
          this.setState({ icon_style: { value: "black", label: "Black" } });

        this.setState({
          logo: res.logo,
          icon: res.icon,
          avatar1: res.avatar1,
          avatar2: res.avatar2,
          brand_name: res.name,
          brand_url: res.url,
          description: res.description || "",
          hex: res.hex,
          hex_tab: res.hex_tab,
          hex_background: res.hex_background,
          hex_header: res.hex_header,
          white: res.white,
          umbrella: res.umbrella,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          is_tasktool_need: res.is_tasktool_need ? res.is_tasktool_need : false,
          isBrandedUserTerms: res.isBrandedUserTerms
            ? res.isBrandedUserTerms
            : false,
          is_fulluser_creatable: res.is_fulluser_creatable || false,
          is_lightuser_creatable:
            res.is_lightuser_creatable !== undefined
              ? res.is_lightuser_creatable
              : true,
          is_ecochat_need: res.is_ecochat_need,
          authentication: res.authentication || {
            interface: "chatbot",
            method: "phone",
          },
          programme: {
            management_fee: {
              active: true,
              price: 0,
            },
            referral_fee: {
              active: true,
              price: 0,
            },
            review_fee: {
              active: true,
              price: 0,
            },
            marketplace_fee: {
              active: true,
              percent: 0,
            },
            linked_retail_incentive: {
              active: true,
              percent: 0,
            },
            ...res.programme,
          },
          sector: res.sector
            ? {
                value: res.sector.toString(),
                label: allSectors[res.sector].name,
              }
            : "",
          salesStage:
            StageOptions.find((item) => item.value === res.salesStage) || "",
          salesManager:
            SalesManagerOptions.find(
              (item) => item.value === res.salesManager
            ) || "",
          campaignManager:
            CampaignManagerOptions.find(
              (item) => item.value === res.campaignManager
            ) || "",
          trialSize: res.trialSize || "",
          bespokeUrl: res.bespokeUrl || "",
          bespokeCrmUrl: res.bespokeCrmUrl || "",
          smsSender: res.smsSender || "",
          potentialSize: res.potentialSize || "",
          interestInCommunity: !!res.interestInCommunity,
          interestInConcierge: !!res.interestInConcierge,
          ticketsAndTaskersIncluded: true, // !!res.ticketsAndTaskersIncluded,
          discountsIncluded: false, // !!res.discountsIncluded,
          registeredCompanyName: res.registeredCompanyName || "",
          registeredCompanyID: res.registeredCompanyID || "",
          territory: res.territory
            ? {
                value: res.territory,
                label: res.territory,
              }
            : {
                value: TerritoryOptions[0],
                label: TerritoryOptions[0],
              },
          registeredAddress: res.registeredAddress || "",
          registeredPostcode: res.registeredPostcode || "",
          registeredStreet: res.registeredStreet || "",
          registeredTown: res.registeredTown || "",
          top10licensor:
            Top10Options.find((item) => item.value === res.top10licensor) ||
            Top10Options[0],
          top10propspect:
            Top10Options.find((item) => item.value === res.top10propspect) ||
            Top10Options[0],
          notes: res.notes || [],
          permissions: res.permissions || {},
          // permissions: res.permissions
          //   ? {
          //       tokenOffers:
          //         res.permissions.tokenOffers === undefined
          //           ? true
          //           : res.permissions.tokenOffers,
          //       earnTokens:
          //         res.permissions.earnTokens === undefined
          //           ? true
          //           : res.permissions.earnTokens,
          //       ecopay:
          //         res.permissions.ecopay === undefined
          //           ? true
          //           : res.permissions.ecopay,
          //       feeds:
          //         res.permissions.feeds === undefined
          //           ? true
          //           : res.permissions.feeds,
          //       friends:
          //         res.permissions.friends === undefined
          //           ? true
          //           : res.permissions.friends,
          //       community:
          //         res.permissions.community === undefined
          //           ? true
          //           : res.permissions.community,
          //       polls:
          //         res.permissions.polls === undefined
          //           ? true
          //           : res.permissions.polls,
          //       shop:
          //         res.permissions.shop === undefined
          //           ? true
          //           : res.permissions.shop,
          //       myId:
          //         res.permissions.myId === undefined
          //           ? true
          //           : res.permissions.myId,
          //       wallet:
          //         res.permissions.wallet === undefined
          //           ? true
          //           : res.permissions.wallet,
          //       timeline:
          //         res.permissions.timeline === undefined
          //           ? true
          //           : res.permissions.timeline,
          //       integration:
          //         res.permissions.integration === undefined
          //           ? true
          //           : res.permissions.integration,
          //     }
          //   : {
          //       concierge: false,
          //       tickets: false,
          //       newchat: false,
          //       tokenOffers: false,
          //       earnTokens: false,
          //       ecopay: false,
          //       feeds: false,
          //       friends: false,
          //       community: false,
          //       polls: false,
          //       shop: false,
          //       myId: false,
          //       wallet: false,
          //       timeline: false,
          //       tokenwallet: false,
          //       cardwallet: false,
          //       bankingwallet: false,
          //       events: false,
          //       messages: false,
          //       reviews: false,
          //       discountOffers: false,
          //       saving: false,
          //       integration: false,
          //     },
          contractStartDate: res.contractStartDate,
          contractLength: res.contractLength,
        });

        Firebase.getAllBrands((res) => {
          let brands = res
            .map((item, index) => {
              let new_item = item;
              new_item.id = index;
              return new_item;
            })
            .filter((item) => item.name !== res.name);
          this.setState({ brands, loading: false });
        });
      });

      Firebase.getAgencyByBrandID(brand, (res) => {
        this.setState({ agencies: res });
      });
    }
  }

  async componentDidUpdate() {
    const { brand, saveChanges } = this.state;
    if (Object.entries(saveChanges).length > 0) {
      await Firebase.updateBrandDataById(brand, saveChanges);
      this.setState({ saveChanges: {} });
    }
  }

  onEditLogo = () => {
    const logo_ele = document.getElementById("logo_img");
    logo_ele.click();
  };
  onEditAvatar1 = () => {
    const avatar_ele = document.getElementById("avatar1_img");
    avatar_ele.click();
  };
  onEditAvatar2 = () => {
    const avatar_ele = document.getElementById("avatar2_img");
    avatar_ele.click();
  };
  onEditIcon = () => {
    const icon_ele = document.getElementById("icon_img");
    icon_ele.click();
  };
  onEditHex = () => {
    const { edit_hex, hex, brand } = this.state;
    if (edit_hex) {
      let hexvalue = hex;
      if (hex.charAt(0) != "#") {
        hexvalue = "#".concat(hex);
        this.setState({ hex: hexvalue });
      }
      this.setState({
        saveChanges: {
          ...this.state.saveChanges,
          hex: hexvalue,
        },
      });
    }
    this.setState({ edit_hex: !edit_hex });
  };
  handleChangeChk = () => {
    const { is_property_brand, brand } = this.state;
    let new_is_property_brand = !is_property_brand;
    this.setState({
      is_property_brand: new_is_property_brand,
    });

    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        is_property_brand: new_is_property_brand,
      },
    });
  };
  handleChangeTaskToolChk = () => {
    const { is_tasktool_need, brand } = this.state;
    let new_is_tasktool_need = !is_tasktool_need;
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        is_tasktool_need: new_is_tasktool_need,
      },
    });
    this.setState({
      is_tasktool_need: new_is_tasktool_need,
    });
  };
  handleChangeFullUserChk = () => {
    const { is_fulluser_creatable } = this.state;
    let new_is_fulluser_creatable = !is_fulluser_creatable;
    this.setState({
      is_fulluser_creatable: new_is_fulluser_creatable,
    });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        is_fulluser_creatable: new_is_fulluser_creatable,
      },
    });
  };
  handleChangeLightUserChk = () => {
    const { is_lightuser_creatable } = this.state;
    let new_is_lightuser_creatable = !is_lightuser_creatable;
    this.setState({
      is_lightuser_creatable: new_is_lightuser_creatable,
    });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        is_lightuser_creatable: new_is_lightuser_creatable,
      },
    });
  };
  handleChangeEcoChatProgrammeChk = () => {
    const { is_ecochat_need } = this.state;
    let new_is_ecochat_need = !is_ecochat_need;
    this.setState({
      is_ecochat_need: new_is_ecochat_need,
    });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        is_ecochat_need: new_is_ecochat_need,
      },
    });
  };
  handleProgramCheck = (name) => () => {
    const { programme } = this.state;
    const category = programme[name];
    this.setState(
      {
        programme: {
          ...programme,
          [name]: {
            ...category,
            active: !category.active,
          },
        },
      },
      () => {
        this.setState({
          saveChanges: {
            ...this.state.saveChanges,
            programme: this.state.programme,
          },
        });
      }
    );
  };
  toggleBrandedUserTerms = () => {
    this.setState({
      isBrandedUserTerms: !this.state.isBrandedUserTerms,
      saveChanges: {
        ...this.state.saveChanges,
        isBrandedUserTerms: !this.state.isBrandedUserTerms,
      },
    });
  };

  handleSelectValueChanged = (name) => (value) => {
    this.setState({ [name]: value.value });
    const saveChanges = {
      ...this.state.saveChanges,
      [name]: name === "sector" ? parseInt(value.value) : value.value,
    };
    if (name === "salesStage") {
      if (value.value === "Test Roll Out" || value.value === "Full Roll Out") {
        saveChanges["top10propspect"] = "none";
      } else {
        saveChanges["top10licensor"] = "none";
      }
    }
    this.setState({
      saveChanges,
    });
  };

  handleSelectIconChanged = (value) => {
    this.setState({ icon_style: value });
  };
  onEditIconStyle = () => {
    const { edit_icon_style, icon_style } = this.state;
    if (edit_icon_style === true) {
      let color = icon_style.value;
      this.setState({
        saveChanges: {
          ...this.state.saveChanges,
          white: color === "white" ? true : false,
        },
      });
    }
    this.setState({ edit_icon_style: !edit_icon_style });
  };
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        [name]: value,
      },
    });
  };

  handleRadioValueChanged = (name, value) => () => {
    this.setState({ [name]: value });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        [name]: value,
      },
    });
  };

  handleProgramPriceChange =
    (name, unit = "price") =>
    (event) => {
      const { programme, brand } = this.state;
      const category = programme[name];

      this.setState(
        {
          programme: {
            ...programme,
            [name]: {
              ...category,
              [unit]: event.target.value,
            },
          },
        },
        () => {
          this.setState({
            saveChanges: {
              ...this.state.saveChanges,
              programme: this.state.programme,
            },
          });
        }
      );
    };

  selectedFile = (e) => {
    const { brand, brand_name } = this.state;
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
            if (id === "logo_img") {
              Firebase.updateLogoBrand(brand, brand_name, img_src);
            } else if (id === "icon_img") {
              Firebase.updateIconBrand(brand, brand_name, img_src);
            } else if (id === "avatar1_img") {
              _this.setState({ img_loading: 1 });
              Firebase.updateFirstAvatarBrand(brand, brand_name, img_src).then(
                (res) => _this.setState({ img_loading: -1 })
              );
            } else if (id === "avatar2_img") {
              _this.setState({ img_loading: 2 });
              Firebase.updateSecondAvatarBrand(brand, brand_name, img_src).then(
                (res) => _this.setState({ img_loading: -1 })
              );
            }
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };

  showNotes = () => {
    const { notes } = this.state;
    const sorted = (notes || []).sort((a, b) => {
      if (a.time < b.time) {
        return 1;
      } else if (a.time > b.time) {
        return -1;
      }

      return 0;
    });
    if (sorted.length)
      return sorted.map((item, index) => {
        return <NoteItem key={index} note={item} isBrand />;
      });
  };

  saveNote = () => {
    const { notes, mynote, username, brand } = this.state;
    let time = new Date().getTime().toString();
    const newNotes = [
      ...notes,
      {
        time,
        note: mynote,
        noteType: "Sales",
        noter: username,
        noterId: localStorage.getItem("uid"),
      },
    ];

    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        notes: newNotes,
      },
    });
    this.setState({
      noteViewVisible: true,
      mynote: "",
    });
  };

  onRemove = () => {
    const { brand } = this.state;
    this.props.history.goBack();
    Firebase.updateBrandDataById(brand, { deactive: true });
  };

  onAddNote = () => {
    this.setState({
      noteViewVisible: false,
    });
  };

  onViewNote = () => {
    this.setState({
      noteViewVisible: true,
    });
  };

  onChangeText = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onAuthenticationChange = (property, option) => {
    const { value } = option;

    this.setState((prevState) => ({
      authentication: {
        ...prevState.authentication,
        [property]: value,
      },

      saveChanges: {
        ...prevState.saveChanges,
        authentication: {
          ...prevState.authentication,
          [property]: value,
        },
      },
    }));
  };

  mapStringToOption = (value) => {
    const label = `${value[0].toUpperCase()}${value.slice(1)}`;
    return { label: label, value: value };
  };

  render() {
    const {
      username,
      role,
      logo,
      icon,
      avatar1,
      avatar2,
      brand_name,
      description,
      brand,
      img_loading,
      brand_url,
      is_property_brand,
      is_lightuser_creatable,
      is_fulluser_creatable,
      is_tasktool_need,
      is_ecochat_need,
      umbrella,
      programme,
      allSectors,
      sector,
      salesStage,
      campaignManager,
      salesManager,
      trialSize,
      bespokeUrl,
      bespokeCrmUrl,
      smsSender,
      potentialSize,
      loading,
      registeredCompanyID,
      registeredCompanyName,
      territory,
      registeredAddress,
      registeredPostcode,
      registeredStreet,
      registeredTown,
      top10licensor,
      top10propspect,
      brands,
      noteViewVisible,
      mynote,
      contractStartDate,
      contractLength,
      permissions,
      hex,
      white,
      isBrandedUserTerms,
      authentication,
    } = this.state;

    const top10LicensorOptionsAvailable = Top10Options.filter((option) => {
      if (option.value === "none") {
        return true;
      }

      return !brands.find((brand) => brand.top10licensor === option.value);
    });

    const top10ProspectOptionsAvailable = Top10Options.filter((option) => {
      if (option.value === "none") {
        return true;
      }

      return !brands.find((brand) => brand.top10propspect === option.value);
    });
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
          is_tasktool_need={is_tasktool_need}
        />
        <main id="main-container">
          <div className="home-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="left-content">
                  <h2>Brand Profile</h2>
                  <h4 className="section-title">Registered Company Name</h4>
                  <input
                    name="registeredCompanyName"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredCompanyName}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">
                    Registered Company ID number
                  </h4>
                  <input
                    name="registeredCompanyID"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredCompanyID}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Territory</h4>
                  <div className="input-container">
                    <Select
                      value={territory}
                      onChange={this.handleSelectValueChanged("territory")}
                      options={TerritoryOptions.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      components={{ MenuList, SingleValue }}
                    />
                  </div>
                  <h4 className="section-title">Registered Postcode</h4>
                  <input
                    name="registeredPostcode"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredPostcode}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Registered Address</h4>
                  <input
                    name="registeredAddress"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredAddress}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Registered Street/Road</h4>
                  <input
                    name="registeredStreet"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredStreet}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Registered Town/City</h4>
                  <input
                    name="registeredTown"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={registeredTown}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Brand Platform Trading Name</h4>
                  <p>{brand_name}</p>
                  <h4 className="section-title">Brand description</h4>
                  <input
                    name="description"
                    className="form-control form-control-md form-control-alt brand-registered-input"
                    value={description}
                    onChange={this.handleInputChange}
                  />
                  <h4 className="section-title">Brand Website Url</h4>
                  <p>{brand_url}</p>
                  <h4 className="section-title">Logo</h4>
                  <div className="logo-container">
                    <img src={logo} width="80%" alt="logo" />
                    <button
                      className="btn btn-success"
                      onClick={this.onEditLogo}
                    >
                      Edit
                    </button>
                  </div>
                  <h4 className="section-title">Icon</h4>
                  <div className="logo-container">
                    <img
                      src={icon}
                      width="80px"
                      height="80px"
                      alt="icon"
                      className="icon"
                    />
                    <button
                      className="btn btn-success mb-2"
                      onClick={this.onEditIcon}
                    >
                      Edit
                    </button>
                    {is_ecochat_need && (
                      <Fragment>
                        <h4 className="section-title">
                          Feminine support avatar
                        </h4>
                        {img_loading !== 1 ? (
                          <img
                            src={avatar1 || user_img}
                            width="80px"
                            height="80px"
                            alt="icon"
                            className="icon"
                          />
                        ) : (
                          <div className="loading">
                            <i className="fa fa-4x fa-sync fa-spin text-muted" />
                          </div>
                        )}
                        <button
                          className="btn btn-success mb-2"
                          onClick={this.onEditAvatar1}
                        >
                          Edit
                        </button>
                        <h4 className="section-title">
                          Masculine support avatar
                        </h4>
                        {img_loading !== 2 ? (
                          <img
                            src={avatar2 || user_img}
                            width="80px"
                            height="80px"
                            alt="icon"
                            className="icon"
                          />
                        ) : (
                          <div className="loading">
                            <i className="fa fa-4x fa-sync fa-spin text-muted" />
                          </div>
                        )}
                        <button
                          className="btn btn-success mb-2"
                          onClick={this.onEditAvatar2}
                        >
                          Edit
                        </button>
                      </Fragment>
                    )}
                  </div>
                </div>
                {role === 0 && (
                  <div className="right-content">
                    <h2>Sale Drivers</h2>
                    <div className="group-input">
                      <p className="group-label">Sector</p>
                      <div className="input-container">
                        <Select
                          value={sector}
                          onChange={this.handleSelectValueChanged("sector")}
                          options={allSectors.map((item, index) => ({
                            value: index.toString(),
                            label: item.name,
                          }))}
                        />
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Sales stage</p>
                      <div className="input-container">
                        <Select
                          value={salesStage}
                          onChange={this.handleSelectValueChanged("salesStage")}
                          options={StageOptions}
                          isDisabled={!!umbrella}
                          components={{
                            MenuList: SingleStageMenuList,
                            SingleValue: SingleStageValue,
                          }}
                        />
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Sales manager</p>
                      <div className="input-container">
                        <Select
                          value={salesManager}
                          onChange={this.handleSelectValueChanged(
                            "salesManager"
                          )}
                          options={SalesManagerOptions}
                        />
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Campaign manager</p>
                      <div className="input-container">
                        <Select
                          value={campaignManager}
                          onChange={this.handleSelectValueChanged(
                            "campaignManager"
                          )}
                          options={CampaignManagerOptions}
                        />
                      </div>
                    </div>

                    <div className="group-input">
                      <p className="group-label">Potential size</p>
                      <div className="input-container">
                        <input
                          type="number"
                          name="potentialSize"
                          className="form-control form-control-md form-control-alt"
                          value={potentialSize}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    {salesStage.value === "Test Roll Out" ||
                    salesStage.value === "Full Roll Out" ? (
                      <div className="group-input">
                        <p className="group-label">Top 10 licensors</p>
                        <div className="input-container">
                          <Select
                            value={top10licensor}
                            onChange={this.handleSelectValueChanged(
                              "top10licensor"
                            )}
                            options={top10LicensorOptionsAvailable}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="group-input">
                        <p className="group-label">Top 10 prospects</p>
                        <div className="input-container">
                          <Select
                            value={top10propspect}
                            onChange={this.handleSelectValueChanged(
                              "top10propspect"
                            )}
                            options={top10ProspectOptionsAvailable}
                          />
                        </div>
                      </div>
                    )}
                    <div className="notes-action-container">
                      <button
                        className="btn btn-white btn-brand-hex"
                        onClick={this.onAddNote}
                        style={{
                          "--hover-color": hex,
                          "--hover-text-color": hex
                            ? idealTextColor(hex)
                            : "black",
                        }}
                      >
                        Add a note
                      </button>
                      <button
                        className="btn btn-white btn-brand-hex"
                        onClick={this.onViewNote}
                        style={{
                          "--hover-color": hex,
                          "--hover-text-color": hex
                            ? idealTextColor(hex)
                            : "black",
                        }}
                      >
                        View notes
                      </button>
                    </div>
                    <div className="note-related-container">
                      {!noteViewVisible && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="note-select-container">
                            <p>Note</p>
                            <textarea
                              rows={5}
                              name="mynote"
                              style={{ width: "80%" }}
                              onChange={this.onChangeText}
                              value={mynote}
                            />
                          </div>
                          <center>
                            <button
                              className="btn btn-success"
                              onClick={this.saveNote}
                            >
                              Save
                            </button>
                          </center>
                        </div>
                      )}
                      {noteViewVisible && this.showNotes()}
                    </div>
                    {/* <h2>Control Console Setup</h2>
                    <div className="group-input">
                      <p className="group-label">Tickets & Taskers included</p>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="ticketsAndTaskers_yes"
                          checked={ticketsAndTaskersIncluded}
                          onClick={this.handleRadioValueChanged(
                            "ticketsAndTaskersIncluded",
                            true
                          )}
                        />
                        <label htmlFor="ticketsAndTaskers_yes">Yes</label>
                        <input
                          type="radio"
                          id="ticketsAndTaskers_no"
                          checked={!ticketsAndTaskersIncluded}
                          onClick={this.handleRadioValueChanged(
                            "ticketsAndTaskersIncluded",
                            false
                          )}
                        />
                        <label htmlFor="ticketsAndTaskers_no">No</label>
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Discounts included</p>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="discounts_yes"
                          checked={discountsIncluded}
                          onClick={this.handleRadioValueChanged(
                            "discountsIncluded",
                            true
                          )}
                        />
                        <label htmlFor="discounts_yes">Yes</label>
                        <input
                          type="radio"
                          id="discounts_no"
                          checked={!discountsIncluded}
                          onClick={this.handleRadioValueChanged(
                            "discountsIncluded",
                            false
                          )}
                        />
                        <label htmlFor="discounts_no">No</label>
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Interest in Community</p>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="community_yes"
                          checked={interestInCommunity}
                          onClick={this.handleRadioValueChanged(
                            "interestInCommunity",
                            true
                          )}
                        />
                        <label htmlFor="community_yes">Yes</label>
                        <input
                          type="radio"
                          id="community_no"
                          checked={!interestInCommunity}
                          onClick={this.handleRadioValueChanged(
                            "interestInCommunity",
                            false
                          )}
                        />
                        <label htmlFor="community_no">No</label>
                      </div>
                    </div> */}
                    {/* <div className="group-input">
                      <p className="group-label">Interest in Concierge</p>
                      <div className="radio-container">
                        <input
                          type="radio"
                          id="concierge_yes"
                          checked={interestInConcierge}
                          onClick={this.handleRadioValueChanged(
                            "interestInConcierge",
                            true
                          )}
                        />
                        <label htmlFor="concierge_yes">Yes</label>
                        <input
                          type="radio"
                          id="concierge_no"
                          checked={!interestInConcierge}
                          onClick={this.handleRadioValueChanged(
                            "interestInConcierge",
                            false
                          )}
                        />
                        <label htmlFor="concierge_no">No</label>
                      </div>
                    </div> */}
                    <h2>Brand Options</h2>
                    <div className="group-input">
                      <p className="group-label">Bespoke community url</p>
                      <div className="input-container">
                        <input
                          name="bespokeUrl"
                          className="form-control form-control-md form-control-alt"
                          value={bespokeUrl}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Bespoke crm url</p>
                      <div className="input-container">
                        <input
                          name="bespokeCrmUrl"
                          className="form-control form-control-md form-control-alt"
                          value={bespokeCrmUrl}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="group-input">
                      <p className="group-label">Bespoke sms sender</p>
                      <div className="input-container">
                        <input
                          name="smsSender"
                          className="form-control form-control-md form-control-alt"
                          value={smsSender}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <h2>Functionality Controls</h2>
                    <Checkbox
                      id="Tasks + tasker tools"
                      classNames="checkbox--reverse"
                      label="Tasks + tasker tools"
                      hex={hex}
                      white={white}
                      checked={is_tasktool_need}
                      onChange={this.handleChangeTaskToolChk}
                    />
                    <Checkbox
                      id="Property tools"
                      classNames="checkbox--reverse"
                      label="Property tools"
                      hex={hex}
                      white={white}
                      checked={is_property_brand}
                      onChange={this.handleChangeChk}
                    />
                    <Checkbox
                      id="Branded user terms"
                      classNames="checkbox--reverse"
                      label="Branded user terms"
                      hex={hex}
                      white={white}
                      checked={isBrandedUserTerms}
                      onChange={this.toggleBrandedUserTerms}
                    />
                    <br />
                    <Checkbox
                      id="User chat"
                      classNames="checkbox--reverse"
                      label="User chat"
                      hex={hex}
                      white={white}
                      checked={is_ecochat_need}
                      onChange={this.handleChangeEcoChatProgrammeChk}
                    />
                    <br />
                    <Checkbox
                      id="Full user creation"
                      classNames="checkbox--reverse"
                      label="Full user creation"
                      hex={hex}
                      white={white}
                      checked={is_fulluser_creatable}
                      onChange={this.handleChangeFullUserChk}
                    />
                    <Checkbox
                      id="Light user creation"
                      classNames="checkbox--reverse"
                      label="Light user creation"
                      hex={hex}
                      white={white}
                      checked={is_lightuser_creatable}
                      onChange={this.handleChangeLightUserChk}
                    />
                    <br />
                    <label
                      className="brand__label"
                      htmlFor="authentication-interface"
                    >
                      Login and registration interface
                    </label>
                    <Dropdown
                      id="authentication-interface"
                      hex={hex}
                      white={white}
                      options={interfaceOptions}
                      value={this.mapStringToOption(authentication.interface)}
                      onClick={(option) =>
                        this.onAuthenticationChange("interface", option)
                      }
                    />
                    <br />
                    <label
                      className="brand__label"
                      htmlFor="authentication-method"
                    >
                      Login and registration contact method
                    </label>
                    <Dropdown
                      id="authentication-method"
                      hex={hex}
                      white={white}
                      options={methodOptions}
                      value={this.mapStringToOption(authentication.method)}
                      onClick={(option) =>
                        this.onAuthenticationChange("method", option)
                      }
                    />
                    <br />

                    <h2>Programme Finances</h2>
                    <div className="subscribed-programmes-container">
                      <h4>Revenues</h4>
                      <div className="programme-row">
                        <div className="active-container">
                          <input
                            type="checkbox"
                            checked={programme.management_fee.active}
                            onChange={this.handleProgramCheck("management_fee")}
                          />
                        </div>
                        <div className="programme-container">
                          <p>Management fee</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <div className="prefix">
                              {CurrencyOptions[territory.value]}
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt"
                              value={programme.management_fee.price}
                              onChange={this.handleProgramPriceChange(
                                "management_fee"
                              )}
                              disabled={!programme.management_fee.active}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="programme-row">
                        <div className="active-container"></div>
                        <div className="programme-container">
                          <p>Minimum Number</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <input
                              type="number"
                              name="trialSize"
                              className="form-control form-control-md form-control-alt"
                              value={trialSize}
                              onChange={this.handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="programme-row">
                        <div className="active-container">
                          <input
                            type="checkbox"
                            checked={programme.referral_fee.active}
                            onChange={this.handleProgramCheck("referral_fee")}
                          />
                        </div>
                        <div className="programme-container">
                          <p>Referral fee</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <div className="prefix">
                              {CurrencyOptions[territory.value]}
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt"
                              value={programme.referral_fee.price}
                              onChange={this.handleProgramPriceChange(
                                "referral_fee"
                              )}
                              disabled={!programme.referral_fee.active}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="programme-row">
                        <div className="active-container">
                          <input
                            type="checkbox"
                            checked={programme.review_fee.active}
                            onChange={this.handleProgramCheck("review_fee")}
                          />
                        </div>
                        <div className="programme-container">
                          <p>Review fee</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <div className="prefix">
                              {CurrencyOptions[territory.value]}
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt"
                              value={programme.review_fee.price}
                              onChange={this.handleProgramPriceChange(
                                "review_fee"
                              )}
                              disabled={!programme.review_fee.active}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="programme-row">
                        <div className="active-container">
                          <input
                            type="checkbox"
                            checked={programme.marketplace_fee.active}
                            onChange={this.handleProgramCheck(
                              "marketplace_fee"
                            )}
                          />
                        </div>
                        <div className="programme-container">
                          <p>Marketplace fee</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <div className="prefix">%</div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt"
                              value={programme.marketplace_fee.percent}
                              onChange={this.handleProgramPriceChange(
                                "marketplace_fee",
                                "percent"
                              )}
                              disabled={!programme.marketplace_fee.active}
                            />
                          </div>
                        </div>
                      </div>
                      <h4>Kick Backs</h4>
                      <div className="programme-row">
                        <div className="active-container">
                          <input
                            type="checkbox"
                            checked={programme.linked_retail_incentive.active}
                            onChange={this.handleProgramCheck(
                              "linked_retail_incentive"
                            )}
                          />
                        </div>
                        <div className="programme-container">
                          <p>Linked retail incentive</p>
                        </div>

                        <div className="price-container">
                          <div className="input-group">
                            <div className="prefix">%</div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt"
                              value={programme.linked_retail_incentive.percent}
                              onChange={this.handleProgramPriceChange(
                                "linked_retail_incentive",
                                "percent"
                              )}
                              disabled={
                                !programme.linked_retail_incentive.active
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <h4>GO & PRO PLANS</h4>
                      <div className="group-input">
                        <p className="group-label">Contract start date</p>

                        <div className="input-container">
                          <input
                            type="date"
                            className="form-control form-control-md form-control-alt"
                            name="contractStartDate"
                            value={contractStartDate}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="group-input">
                        <p className="group-label">Contract length</p>

                        <div className="input-container">
                          <input
                            type="number"
                            className="form-control form-control-md form-control-alt"
                            name="contractLength"
                            value={contractLength}
                            onChange={this.handleInputChange}
                            min={1}
                            max={18}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="actions-container">
                      {/* <button
                        type="button"
                        className="btn push btn-green"
                        onClick={this.onSaveChanges}
                      >
                        Save Changes
                      </button> */}
                      <button
                        type="button"
                        className="btn btn-danger push"
                        data-toggle="modal"
                        data-target="#remove_brand"
                      >
                        Delete Brand
                      </button>
                    </div>
                  </div>
                )}
                <input
                  type="file"
                  id="logo_img"
                  name="logo-file-input"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.selectedFile}
                />
                <input
                  type="file"
                  id="icon_img"
                  name="icon-file-input"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.selectedFile}
                />
                <input
                  type="file"
                  id="avatar1_img"
                  name="icon-file-input"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.selectedFile}
                />
                <input
                  type="file"
                  id="avatar2_img"
                  name="icon-file-input"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={this.selectedFile}
                />
              </React.Fragment>
            )}
          </div>
        </main>
        <ConfirmationModal
          title="Are you sure you want to remove this brand?"
          id="remove_brand"
          onClick={this.onRemove}
          hex={hex}
          white={white}
        />
      </div>
    );
  }
}
export default Brand;



// WEBPACK FOOTER //
// ./src/screens/Brand/index.js